<script setup lang="ts">
import { EventOptionsTypeOptions } from "@/utils/PocketBaseAdapter";
import { requiredValidator, maxLengthValidator } from "@validators";

const option = defineModel<any>({ required: true });
const typeList = Object.values(EventOptionsTypeOptions);

const emit = defineEmits<{
  remove: [];
}>();

const isOpen = ref(option.value.name ? false : true);
</script>

<template>
  <div class="mb-4 border rounded-sm px-2">
    <!-- Collapsible header -->
    <div
      class="d-flex align-center justify-space-between px-2 py-2 rounded cursor-pointer ticket-header"
      @click="isOpen = !isOpen"
    >
      <span class="font-weight-medium">
        {{ option.name || "New Option" }}
        <v-icon v-if="option.required" icon="mdi-asterisk" size="x-small"/>
      </span>
      <div>
        <IconBtn @click="emit('remove')">
          <VIcon size="20" icon="mdi-delete" />
          <VTooltip activator="parent" open-delay="400">
            Remove
          </VTooltip>
        </IconBtn>
        <VIcon :icon="isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
      </div>
    </div>

    <div v-if="isOpen" class="pt-2 pa-3 px-2">
      <VRow>
        <VCol sm="6" cols="12">
          <VTextField
            v-model="option.name"
            :rules="[requiredValidator]"
            label="Name"
            required
          />
        </VCol>
        <VCol sm="6" cols="12">
          <VSelect
            v-model="option.type"
            :items="typeList"
            :rules="[requiredValidator]"
            label="Type"
          />
        </VCol>
      </VRow>
      <VRow>
        <VCol cols="12" md="6">
          <VTextField
            v-model="option.prompt"
            :rules="[requiredValidator, maxLengthValidator(option.prompt, 35)]"
            label="Prompt"
            required
          />
        </VCol>
        <VCol cols="12" md="6">
          <VTextField
            v-model="option.hintText"
            label="Hint text"
          />
        </VCol>
        <VCol cols="12" v-if="option.type === 'Selection'">
          <VTextField
            v-model="option.selections"
            :rules="[requiredValidator]"
            label="Selections"
            hint="Comma separated list of selection options"
          />
        </VCol>
        <VCol cols="12" md="6">
          <VCheckbox
            label="Required"
            v-model="option.required"
          />
        </VCol>
      </VRow>
    </div>
  </div>
</template>
